module.exports = {
	"pathContext": {}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/index.json
// module chunks = 9347362237655822000